<template>
    <div class="brief">
        <div class="row">
            <!-- 左边 -->
            <div class="fl w235">
                <div class="sideTitle2">
                    <div class="list-img">
                        <h5>关于协会</h5>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item,index) in list" ref="boxll" :class="isActive == index?'active': ''"
                                :key="index" @click="listClick(item.id,index)">
                                <p>{{item.text}}</p>
                                <i class="el-icon-arrow-right"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="sideImg">
                    <img src="../../../assets/image/mxu.jpg" alt="">
                </div>
            </div>
            <!-- 右边 -->
            <div class="fr w750">
                <div class="pageBox2">
                    <div class="about">
                        <div class="title">{{dataLeaders.title}}</div>
                        <div class="text-cell">
                            <ul>
                                <li>
                                    <p>时间：{{dataLeaders.createTime}}</p>
                                </li>
                                <li>
                                    <p>来源：{{dataLeaders.source}}</p>
                                </li>
                                <li>
                                    <p>编辑: {{dataLeaders.editor}}</p>
                                </li>
                                <li>
                                    <p>点击次: {{dataLeaders.hits}}</p>
                                </li>
                                <li>
                                    <p>字体: </p>
                                    <p>
                                        <span v-for="(item,index) in fontSize" :key="item.id"
                                            :class="asActive==index ? 'active' : '' "
                                            @click="fontSizeClick(item.id,index)">
                                            {{item.textSize}}
                                        </span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <el-divider></el-divider>
                        <div class="content-cell-box" ref="box">
                            <div class="leader">
                                <div class="leader-left">
                                    <img :src="leaderData.img" alt="">
                                </div>
                                <div class="leader-ragint">
                                    <div class="leader-title">会长：{{leaderData.leaderName}}</div>
                                    <el-divider></el-divider>
                                    <div class="leader-content">简介： {{leaderData.content}}</div>
                                </div>
                            </div>
                            <el-divider></el-divider>
                            <div class="leadervice">
                                <div class="leader-title" style="margin-bottom:10px;">副会长</div>
                                <div class="layout-vice">
                                    <div class="lay-cell" v-for="item in vicePresidentData" 
                                    :key="item.id">
                                        <div class="name-cell">名字：{{item.leaderName}}</div>
                                        <div class="name-company">单位：{{item.company}}</div>
                                    </div>
                                </div>
                            </div>
                            <el-divider></el-divider>
                            <div class="leadervice">
                                <div class="leader-title" style="text-align: left;">秘书长：{{secretaryGeneral.leaderName}}</div>
                                <div class="leader-company" style="text-align: left;">单位：{{secretaryGeneral.company}}</div>
                                <div class="leader-company" style="text-align: left;">简介：{{secretaryGeneral.content}}</div>
                            </div>
                            <el-divider></el-divider>
                            <div class="leadervice">
                                <div class="leader-title" style="text-align: left;">监事长：{{chiefSupervisor.leaderName}}</div>
                                <div class="leader-company" style="text-align: left;">单位：{{chiefSupervisor.company}}</div>
                            </div>
                            <el-divider></el-divider>
                            <div class="leadervice">
                                <div class="leader-title" style="margin-bottom:10px;">监事</div>
                                <div class="layout-vice">
                                    <div class="lay-cell" v-for="item in supervisor" 
                                    :key="item.id">
                                        <div class="name-cell">名字：{{item.leaderName}}</div>
                                        <div class="name-company">单位：{{item.company}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dataLeaders: [],
                isActive: 2,
                asActive: 1,
                fontSize: [{
                    textSize: '大',
                    id: 1
                }, {
                    textSize: '中',
                    id: 2
                }, {
                    textSize: '小',
                    id: 3
                }],
                list: [{
                        text: '协会简介',
                        id: 1
                    },
                    {
                        text: '协会章程',
                        id: 2
                    },
                    {
                        text: '协会领导',
                        id: 3
                    },
                    {
                        text: '协会架构',
                        id: 4
                    }
                
                ],
                leaderData: '', // 会长
                vicePresidentData: [], // 副会长
                secretaryGeneral: '', // 秘书长
                chiefSupervisor: '', // 监事长
                supervisor: [], // 监事
            }
        },
        mounted() {
            this.getlist();
            this.geLleader();
        },
        methods: { 
            // 获取协会领导 
            geLleader(){
                this.$axios.get('/websiteData/leader/getListByPost').then(res => {
                    this.leaderData = res.data.data.president[0];
                    console.log(this.leaderData.img)
                    this.secretaryGeneral = res.data.data.secretaryGeneral[0];
                    this.vicePresidentData = res.data.data.vicePresident;
                    this.chiefSupervisor = res.data.data.chiefSupervisor[0];
                    this.supervisor = res.data.data.supervisor;
                    // console.log(res.data.data)
                })
            },
            // 获取协会领导的时间之类的数
            getlist() {
                this.$axios.get('/websiteData/title/getTitleBySubType/leaders').then(res => {
                    this.dataLeaders = res.data.data[0];
                })
            },
            // 设置字体的大小
            fontSizeClick(id, index) {
                this.asActive = index;
                if (id == 1) {
                    this.$refs.box.style.fontSize = '16px'
                } else if (id == 2) {
                    this.$refs.box.style.fontSize = '14px'
                } else if (id == 3) {
                    this.$refs.box.style.fontSize = '12px'
                }
            },
            listClick(id) {
                if (id == 1) {
                    this.isActive = 0;
                    this.$router.push({
                        path: '/brief',
                    })
                } else if (id == 2) {
                    this.isActive = 1;
                    this.$router.push({
                        path: '/rules',
                    })
                } else if (id == 3) {
                    this.isActive = 2;
                    this.$router.push({
                        path: '/leader',
                    })
                } else if (id == 4) {
                    this.isActive = 3;
                    this.$router.push({
                        path: '/framework',
                    })
                }
            }
        }
    }
</script>
<style lang="scss">
    .content-cell-box {
        overflow: hidden;
        .leader{
            width: 700px;
            height: 300px;
            overflow: hidden;
            display: flex;
            justify-content: space-between;
            .leader-left{
                width: 200px;
                height: 300px;
                img{
                    width: 100%;
                    height: 100%;
                    display: block;
                }
            }
            .leader-ragint{
                width: 480px;
                height: 300px;
                .leader-title{
                    font-size: 24px;
                    line-height: 30px;
                    font-family:'微软雅黑';
                }
                .leader-text{
                    font-size: 18px;
                    margin-bottom: 20px;
                }
                .leader-content{
                    text-indent: 20px;
                }
            }
        }
        .leadervice{
            overflow: hidden;
            .leader-title{
                font-size: 20px;
                padding: 10px 0;
                font-weight: 600;
                font-family: Arial,'微软雅黑';
                text-align: center;
            }
            .layout-vice{
                width: 100%;
                overflow: hidden;
                display: flex;
                flex-wrap: wrap;
                .lay-cell{
                    width: 344px;
                    padding: 10px 0;
                    border-bottom: 1px #dadada solid;
                    .name-cell{
                        font-weight: 600;
                        font-size: 15px;
                    }
                    .name-company{
                        font-size: 13px;
                    }
                }
            }
            .leader-company{
                font-size: 13px;
            }
            p{
                text-indent: 20px;
            }
        }
        p {
            width: 700px;

            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .brief {
        margin: 20px 0;
        overflow: hidden;

        .row {
            width: 1000px;
            background-color: #FFF;
            margin: 0 auto;

            .w235 {
                width: 235px;
                left: -8px;

                .sideImg {
                    text-align: center;
                    padding: 20px 0;
                }
            }

            .w750 {
                width: 750px;
                position: relative;
                right: -7px;

                .pageBox2 {
                    min-height: 830px;
                    border: 1px #DDDDDD solid;
                    border-radius: 5px;
                    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
                        0 0 6px 0 rgba(0, 0, 0, 0.04);

                    .about {
                        padding: 30px 30px;
                        line-height: 20px;
                        text-align: justify;
                        .title{
                            line-height: 30px;
                            margin-bottom: 30px;
                            text-align: center;
                        }
                    }
                }
            }
        }
    }
</style>